// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandler, createHandlerChainRunner, HasOnError } from "@insite/client-framework/HandlerCreator";
import { getDealers, GetDealersApiParameter } from "@insite/client-framework/Services/DealerService";
import { DealerCollectionModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandler<
    GetDealersApiParameter & { getAllDealers?: boolean } & HasOnError<string>,
    DealerCollectionModel
>;

export const DispatchBeginLoadAllLocations: HandlerType = props => {
    props.dispatch({
        type: "xAllLocations/BeginLoadAllLocations",
    } as any);
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getDealers(props.apiParameter);
    } catch (error) {
        props.parameter.onError?.(error.errorMessage);
        props.dispatch({
            type: "xAllLocations/FailedLoadAllLocations",
        } as any);
        return false;
    }
};

export const SortDealersByCityName: HandlerType = props => {
    if (props.apiResult.dealers) {
        props.apiResult.dealers = props.apiResult?.dealers?.sort((a: { city: string }, b: { city: string }) =>
            a.city.toLowerCase().localeCompare(b.city.toLowerCase()),
        );
    }
};

export const DispatchCompleteLoadAllLocations: HandlerType = props => {
    props.dispatch({
        type: "xAllLocations/CompleteLoadAllLocations",
        allLocations: props.apiResult,
    } as any);
};

export const chain = [
    DispatchBeginLoadAllLocations,
    PopulateApiParameter,
    RequestDataFromApi,
    SortDealersByCityName,
    DispatchCompleteLoadAllLocations,
];

const loadAllLocations = createHandlerChainRunner(chain, "loadAllLocations");

export default loadAllLocations;
